// extracted by mini-css-extract-plugin
export default {"container":"description_container__yW+dg","messageContent":"description_messageContent__MHqYS"};